/* eslint-disable no-undef */
import React from 'react';
import { Provider } from 'react-redux';
import ReactOnRails from 'react-on-rails';
import PropTypes from 'prop-types';
import SuccessOrderPageBody from '../../containers/SuccessOrderPage/SuccessOrderPageBody/SuccessOrderPageBody';
import './SuccessOrderPage.sass';
import Header from '../../containers/Header/Header';
import Footer from '../Footer';

const SuccessOrderPage = (props) => {
  const appStore = ReactOnRails.getStore('appStore');

  const {
    footerData,
    unsuccess,
    formType,
    locationsCountryPath,
    lastOrderEmail,
  } = props;

  return (
    <div>
      <Provider store={appStore}>
        <div className="main-wrapper-success-page">
          <Header />
          <div className="content-container">
            <div className="thank-you-page">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <SuccessOrderPageBody
                      unsucces={unsuccess}
                      formType={formType}
                      locationsCountryPath={locationsCountryPath}
                      lastOrderEmail={lastOrderEmail}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer footerData={footerData} />
        </div>

      </Provider>
    </div>
  );
};


SuccessOrderPage.propTypes = {
  footerData: PropTypes.oneOfType([PropTypes.object]),
  unsuccess: PropTypes.bool,
  formType: PropTypes.string,
  locationsCountryPath: PropTypes.string,
  lastOrderEmail: PropTypes.string,
};

SuccessOrderPage.defaultProps = {
  footerData: {},
  unsuccess: false,
  formType: '',
  locationsCountryPath: '',
  lastOrderEmail: '',
};

export default SuccessOrderPage;
